import { render, staticRenderFns } from "./bindMember.vue?vue&type=template&id=0cc3fd77&scoped=true&"
import script from "./bindMember.vue?vue&type=script&lang=js&"
export * from "./bindMember.vue?vue&type=script&lang=js&"
import style0 from "./bindMember.vue?vue&type=style&index=0&id=0cc3fd77&prod&scoped=true&lang=less&"
import style1 from "./bindMember.vue?vue&type=style&index=1&id=0cc3fd77&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc3fd77",
  null
  
)

export default component.exports